import React from 'react';
import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import isEmpty from '../../utils/isEmpty';
import StreamField from '../../components/StreamField';
import CardListIndex from '../../components/CardListIndex/CardListIndex.js';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';

import styles from './ArticlePage.module.scss';

import Hero from '../../components/Hero';

const ArticlePage = ({
    breadcrumbs,
    hero,
    contentBlocks,
    title,
    cardListIndex,
}) => {
    return (
        <div className={styles['ArticlePage']}>
            {!isEmpty(hero) && <Hero {...hero} />}
            <Breadcrumbs {...breadcrumbs} modifier="ArticlePage" />

            <div className={styles['ArticlePage__Container']}>
                <h1 className={styles['ArticlePage__Title']}>{title}</h1>
            </div>

            {!isEmpty(contentBlocks) && (
                <StreamField items={contentBlocks} modifier="ArticlePage" />
            )}
            <CardListIndex {...cardListIndex} />
        </div>
    );
};

ArticlePage.propTypes = {
    navigation: PropTypes.object,
    title: PropTypes.string.isRequired,
    contentBlocks: PropTypes.array,
};

ArticlePage.defaultProps = {
    navigation: {},
    title: '',
    contentBlocks: [],
};

export default basePageWrap(ArticlePage);
